module.exports = __webpack_public_path__ + "static/media/info.e6d6987f.svg";